<template>
  <div class="all-wrapper solid-bg-all top-bar-fixed disable-scrollbars">
    <TopBar v-if="isAuthenticated" :user="getUser" :openSessions="getOpenSessions" />
    <Search v-if="isAuthenticated" />
    <div class="layout-w">
      <!-- <NavigationMobile v-if="isAuthenticated"/> -->
      <Navigation v-if="isAuthenticated" :client="getClientDetails" :modules="getClientModules"/>
      <div class="content-w">

        <div class="content-panel-toggler">
          <i class="os-icon os-icon-grid-squares-22"></i>
          <span>Sidebar</span>
        </div>
        <div class="content-i">
          <Delinquent v-show="getClientDetails.is_overdue == 1" />
          <Loader v-show="isLoading === 'true' && isError == 'false'" />
          <Error v-show="isError === 'true'" />
          <transition name="zoom-fade" >
            <router-view v-show="isLoading === 'false'" />
          </transition>
        </div>
      </div>
    </div>

    <Toast :show="isShowToast" />

    <Modal v-if="isShowModal" />
    <CopyModal v-if="isShowCopyModal" :settings="copyModalSettings"/>
    <div class="display-type"></div>
  </div>
</template>

<style>
  @import "https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css";
</style>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import Navigation from '@/components/common/Navigation'
import NavigationMobile from '@/components/common/NavigationMobile'
import Search from '@/components/common/Search'
import TopBar from '@/components/common/TopBar'
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
import Toast from '@/components/common/Toast'
import Modal from '@/components/common/Modal'
import Delinquent from '@/components/common/Delinquent'
import CopyModal from '@/components/common/CopyModal'

export default {
  name: 'home',
  components: {
    Breadcrumb,
    Navigation,
    NavigationMobile,
    Search,
    TopBar,
    Loader,
    Toast,
    Error,
    Modal,
    CopyModal,
    Delinquent
  },
  computed: {
    isLoading () {
      return this.$store.getters.loading
    },
    isError () {
      return this.$store.getters.error
    },
    isShowToast () {
      return this.$store.getters.toastSettings.show
    },

    isShowModal () {
      return this.$store.getters.modalSettings.show && this.$store.getters.modalSettings.contentType == 'image'
    },
    isShowCopyModal () {
      return this.$store.getters.modalSettings.show && this.$store.getters.modalSettings.contentType == 'copy'
    },
    copyModalSettings () {
      return this.$store.getters.modalSettings
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    getUser () {
      return this.$store.getters.authUser
    },
    getOpenSessions () {
      return this.$store.getters.openSessions
    },
    getClientDetails () {
      return this.$store.getters.clientDetails
    },
    getClientModules () {
      return this.$store.getters.clientModules
    }

  }
}
</script>

<style>

.zoom-fade-enter-active,
.zoom-fade-leave-active {
  transition: transform .35s, opacity .28s ease-in-out;
}
.zoom-fade-enter {
    transform: scale(0.97);
  opacity: 0;
}

.zoom-fade-leave-to {
    transform: scale(1.03);
    opacity: 0;
}
</style>
